export default __webpack_public_path__ + "static/media/seguro-vida.62a82f7e.png";